module.exports = __webpack_public_path__ + "static/img/service_banana03.5873837.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/service_banana03.png
// module id = CL+Q
// module chunks = 0